import { IAutomationObject } from "../../types";

export interface IEnergyRate extends IAutomationObject {
    valuePerUnit: number,
    timeFrom: Date,
    timeTo: Date,
}

export interface ICO2Rate extends IEnergyRate {
}

export interface ICostRate extends IEnergyRate {
    currencyCode: string
}

export const schemaCO2Rate = "AutomationApps.Energy.CO2Rate";
export const schemaCostRate =  "AutomationApps.Energy.CostRate";

export const energyRateModelId =  "dtmi:AutomationApps:Energy:EnergyRate";
export const co2RateModelId =  "dtmi:AutomationApps:Energy:CO2Rate";
export const costRateModelId =  "dtmi:AutomationApps:Energy:CostRate";